module.exports = __webpack_public_path__ + "img/a46ty-8jeug.8402ee8d.png";